<template>
    <h2 class="text-2xl text-primary font-bold mb-3.5">{{ title }}</h2>
    <Accordion :accordions="accordions"/>
</template>
<script>
import Accordion from "@/Components/UI/Modals/Accordion.vue"

    export default {
        components: {
            Accordion
        },
        props: {
            title: String,
            accordions: Array
        }
    }
</script>
